import creditCardPreCalculationApi from '../../api/creditcard-precalculation-api';
const CREDITCARD_PRECALCULATION_SUCCESS_CALCULATION = 'creditCardPreCalculationSuccessCalculation';
const CREDITCARD_PRECALCULATION_SET_INIT_DATA = 'creditCardPreCalculationSetInitData';
const CREDITCARD_PRECALCULATION_SET_CAPTCHA_DATA = 'creditCardPreCalculationSetCaptchaData';
const CREDITCARD_PRECALCULATION_SET_MINIMUM_WAGE = 'creditCardPreCalculationSetMinimumWage';
const CREDITCARD_PRECALCULATION_TECHNICAL_ERROR = 'creditCardPreCalculationTechnicalError';
const CREDITCARD_PRECALCULATION_CAPTCHA_ERROR = 'creditCardPreCalculationCaptchaError';
const CREDITCARD_PRECALCULATION_NO_CAPTCHA_ERROR = 'creditCardPreCalculationNoCaptchaError';
const CREDITCARD_PRECALCULATION_CALCULATION_SESSION_ID = 'creditCardPreCalculationCalculationSessionId';
const CREDITCARD_PRECALCULATION_OLD_CALCULATION_SESSION_ID = 'creditCardPreCalculationOldCalculationSessionId';
const CREDITCARD_PRECALCULATION_SET_OPERATOR_TOKEN = 'creditCardPreCalculationSetOperatorToken';
const CAPTCHA_ERROR_CODE = 'VE0005';

const creditCardPreCalculationState = {
	loading: false,
	technicalError: false,
	preCalculated: false,
	initData: null,
	captcha: null,
	calculationResult: null,
	captchaError: null,
	minimumWage: null,
	calculationSessionId: null,
	operatorToken: '',
	oldSessionId: null
};

const creditCardPreCalculationActions = {
	getInitData({ commit }) {
		creditCardPreCalculationApi.getInitData().then(
			(response) => {
				commit(CREDITCARD_PRECALCULATION_SET_INIT_DATA, response.data);
				commit(CREDITCARD_PRECALCULATION_SET_CAPTCHA_DATA, response.data.captcha);
				commit(CREDITCARD_PRECALCULATION_SET_MINIMUM_WAGE, response.data.minimumWage);
			},
			(error) => {
				commit(CREDITCARD_PRECALCULATION_TECHNICAL_ERROR, error.data);
			}
		);
	},
	preCalculate({ commit, state }, data) {
		return new Promise((resolve, reject) => {
			creditCardPreCalculationApi.preCalculate(data, state.operatorToken).then(
				(response) => {
					let oldSessionId = state.initData.sessionId;
					commit(CREDITCARD_PRECALCULATION_OLD_CALCULATION_SESSION_ID, oldSessionId);
					commit(CREDITCARD_PRECALCULATION_CALCULATION_SESSION_ID, state.initData.sessionId);
					commit(CREDITCARD_PRECALCULATION_SET_CAPTCHA_DATA, response.data.captcha);
					commit(CREDITCARD_PRECALCULATION_SET_INIT_DATA, response.data);
					commit(CREDITCARD_PRECALCULATION_SUCCESS_CALCULATION, response.data);
					resolve(oldSessionId);
				},
				(error) => {
					commit(CREDITCARD_PRECALCULATION_SET_INIT_DATA, error.response.data);
					commit(CREDITCARD_PRECALCULATION_TECHNICAL_ERROR);
					commit(CREDITCARD_PRECALCULATION_SET_CAPTCHA_DATA, error.response.data.captcha);
					if (error.response.data.errors.captchaText.indexOf(CAPTCHA_ERROR_CODE) != -1) {
						commit(CREDITCARD_PRECALCULATION_CAPTCHA_ERROR);
					} else {
						commit(CREDITCARD_PRECALCULATION_NO_CAPTCHA_ERROR);
					}
					reject();
				}
			);
		});
	},
	sendTa(context, data) {
		return creditCardPreCalculationApi.sendTa(data);
	},
	postStartCalculation({ commit }, data) {
		return new Promise((resolve) => {
			creditCardPreCalculationApi.startCalculation(data).then(
				() => {
					return resolve();
				},
				(error) => {
					commit(CREDITCARD_PRECALCULATION_TECHNICAL_ERROR, error.data);
				}
			);
		});
	},
	setOperatorToken({ commit }, operatorToken) {
		commit(CREDITCARD_PRECALCULATION_SET_OPERATOR_TOKEN, operatorToken);
	}
};

const creditCardPreCalculationMutations = {
	[CREDITCARD_PRECALCULATION_SUCCESS_CALCULATION](state, responseData) {
		state.calculationResult = responseData;
		state.preCalculated = true;
	},
	[CREDITCARD_PRECALCULATION_SET_INIT_DATA](state, responseData) {
		state.initData = responseData;
		state.loading = false;
	},
	[CREDITCARD_PRECALCULATION_TECHNICAL_ERROR](state) {
		state.technicalError = true;
	},
	[CREDITCARD_PRECALCULATION_SET_CAPTCHA_DATA](state, captcha) {
		state.captcha = captcha;
	},
	[CREDITCARD_PRECALCULATION_SET_MINIMUM_WAGE](state, minimumWage) {
		state.minimumWage = minimumWage;
	},
	[CREDITCARD_PRECALCULATION_CAPTCHA_ERROR](state) {
		state.captchaError = true;
	},
	[CREDITCARD_PRECALCULATION_NO_CAPTCHA_ERROR](state) {
		state.captchaError = false;
	},
	[CREDITCARD_PRECALCULATION_CALCULATION_SESSION_ID](state, sessionId) {
		state.calculationSessionId = sessionId;
	},
	[CREDITCARD_PRECALCULATION_SET_OPERATOR_TOKEN](state, operatorToken) {
		state.operatorToken = operatorToken;
	},
	[CREDITCARD_PRECALCULATION_OLD_CALCULATION_SESSION_ID](state, oldSessionId) {
		state.oldSessionId = oldSessionId;
	}
};

export default {
	namespaced: true,
	state: creditCardPreCalculationState,
	mutations: creditCardPreCalculationMutations,
	actions: creditCardPreCalculationActions
};
